// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var $dot$dot = require("..");
var Js_exn = require("bs-platform/lib/js/js_exn.js");
var Belt_List = require("bs-platform/lib/js/belt_List.js");

function getDirection(pin) {
  var dir = pin.direction;
  switch (dir) {
    case "input" :
        return /* Input */0;
    case "output" :
        return /* Output */1;
    default:
      return Js_exn.raiseTypeError("Pin direction should be \"input\" or \"output\", got \"" + (String(dir) + "\""));
  }
}

function isOutput(pin) {
  return getDirection(pin) === /* Output */1;
}

function isInput(pin) {
  return getDirection(pin) === /* Input */0;
}

function normalizeLabels(pins) {
  return Belt_List.fromArray($dot$dot.normalizeEmptyPinLabels(Belt_List.toArray(pins)));
}

function getKey(pin) {
  return pin.key;
}

function getPrimitiveTypeExn(pin) {
  var tp = pin.type;
  switch (tp) {
    case "boolean" :
        return /* Boolean */1;
    case "byte" :
        return /* Byte */3;
    case "number" :
        return /* Number */2;
    case "pulse" :
        return /* Pulse */0;
    case "string" :
        return /* String */4;
    default:
      return Js_exn.raiseTypeError("Pin type should be \"pulse\", \"boolean\", \"number\", etc, got \"" + (String(tp) + "\""));
  }
}

function getLabel(pin) {
  return pin.label;
}

function getType(pin) {
  return pin.type;
}

exports.getDirection = getDirection;
exports.isOutput = isOutput;
exports.isInput = isInput;
exports.normalizeLabels = normalizeLabels;
exports.getPrimitiveTypeExn = getPrimitiveTypeExn;
exports.getKey = getKey;
exports.getLabel = getLabel;
exports.getType = getType;
/* .. Not a pure module */



// WEBPACK FOOTER //
// ../src/Pin.bs.js